import { createSelector } from 'reselect';
import { getPassengersText } from '../../utils/common/utils';

export const homeStateSelector = state => state.home;

export const flightSearchWidgetSelector = createSelector(
  homeStateSelector,
  home => home.searchWidgetData
);

export const uuidSelector = createSelector(homeStateSelector, home => home.uuid);

export const sourceSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.source
);

export const destinationSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.destination
);

export const departureSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.departure
);

export const arrivalSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.arrival
);

export const passengerSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.passengers
);

export const passengerTxtSelector = createSelector(flightSearchWidgetSelector, searchWidget => {
  const passengers = searchWidget.passengers;
  return getPassengersText(passengers);
});

export const flightClassSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.flightClass
);

export const isEconomyClassSelector = createSelector(
  flightClassSelector,
  flightClass => flightClass.name === 'Economy' && flightClass.value === 'E'
);

export const journeyTypeSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.journeyType
);

export const travelTypeSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.travelType
);

export const selectedFareIdentifierSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.selectedFareIdentifier
);

export const isNonStopSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.isNonStop
);

export const isNonStopReturnSelector = createSelector(
  flightSearchWidgetSelector,
  searchWidget => searchWidget.isNonStopReturn
);

export const tempSearchWidgetDataSelector = createSelector(
  homeStateSelector,
  home => home.tempSearchWidget
);

export const searchWidgetSourceSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.source
);

export const searchWidgetDestinationSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.destination
);

export const searchWidgetDepartureSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.departure
);

export const searchWidgetArrivalSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.arrival
);

export const searchWidgetPassengersSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.passengers
);

export const searchWidgetPassengersTxtSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => {
    const passengers = tempSearchWidgetData.passengers;
    return getPassengersText(passengers);
  }
);

export const searchWidgetFlightClassSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.flightClass
);

export const searchWidgetJourneyTypeSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.journeyType
);

export const searchWidgetIsDefaultSrcAndDestSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.isDefaultSrcAndDest
);

export const searchWidgetSelectedFareIdentifierSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.selectedFareIdentifier
);

export const searchWidgetIsNonStopSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.isNonStop
);
export const searchWidgetIsNonStopReturnSelector = createSelector(
  tempSearchWidgetDataSelector,
  tempSearchWidgetData => tempSearchWidgetData.isNonStopReturn
);

export const flavourSelector = createSelector(homeStateSelector, home => home.flavour);

export const offersDataSelector = createSelector(homeStateSelector, home => home.offersData);

export const easyVisaDestinationDataSelector = createSelector(
  homeStateSelector,
  home => home.easyVisaDestinationData
);

export const ourPromisesDataSelector = createSelector(homeStateSelector, home => home.ourPromises);

export const userStoriesDataSelector = createSelector(homeStateSelector, home => home.userStories);

export const fareOptionsInfoSelector = createSelector(
  homeStateSelector,
  home => home.fareOptionsInfo
);

export const isFareOptionsReceivedSelector = createSelector(
  homeStateSelector,
  home => home.isFareOptionsReceived
);

export const mwebToAppInfoSelector = createSelector(
  homeStateSelector,
  home => home.mwebToAppSectors
);

export const isRoundTripSelector = createSelector(journeyTypeSelector, journeyType => {
  return journeyType === 'rt';
});

// USE THIS WHERE DOM RT CHECK IS TO BE APPLIED
export const domesticRoundTripSelector = createSelector(
  [journeyTypeSelector, travelTypeSelector],
  (journeyType, travelType) => {
    const isRoundTrip = journeyType === 'rt';
    const isDomestic = travelType === 'domestic';
    return isRoundTrip && isDomestic;
  }
);

export const internationalRoundTripSelector = createSelector(
  [journeyTypeSelector, travelTypeSelector],
  (journeyType, travelType) => {
    const isRoundTrip = journeyType === 'rt';
    const isInternational = travelType === 'international';
    return isRoundTrip && isInternational;
  }
);

export const totalPaxSelector = createSelector(flightSearchWidgetSelector, searchWidget => {
  const { passengers } = searchWidget;
  return passengers.adult + passengers.child + passengers.infant;
});

export const recentSearchDataSelector = createSelector(
  homeStateSelector,
  home => home.recentSearchData
);

export const homeSeoDataSelector = createSelector(homeStateSelector, home => home.homeSeoData);

export const flightSearchDataSelector = createSelector(
  [flightSearchWidgetSelector, flavourSelector],
  (searchWidget, flavour) => ({
    ...searchWidget,
    flavour
  })
);

export const isHistoryListeningSelector = createSelector(
  homeStateSelector,
  home => home.isHistoryListening
);

export const updateSearchResultSelector = createSelector(
  homeStateSelector,
  home => home.updateSearchResult
);

export const isSSRSelector = createSelector(homeStateSelector, home => home.ssr);

export const experimentDetailSelector = createSelector(
  [homeStateSelector, isSSRSelector],
  (home, ssr) => {
    // const experimentNameMap = {
    //   38: {
    //     name: 'GI_FLT_MWEB_SRP_SSR',
    //     value: ssr ? 'true' : 'false',
    //     variant: 'mweb_srp_ssr'
    //   }
    // };

    // if (
    //   home.experimentDetails &&
    //   home.experimentDetails.length &&
    //   home.experimentDetails[0].exp_experiment_id
    // ) {
    //   const experimentDetails = [];
    //   for (let i = 0; i < home.experimentDetails.length; i++) {
    //     const expId = home.experimentDetails[i].exp_experiment_id;
    //     if (expId && experimentNameMap[expId]) {
    //       experimentDetails.push({
    //         experiment_name: experimentNameMap[expId].name,
    //         experiment_value: experimentNameMap[expId].value,
    //         experiment_variant_id: experimentNameMap[expId].variant
    //       });
    //     }
    //   }
    //   return experimentDetails;
    // }
    return home.experimentDetails;
  }
);

export const experimentMetaDataSelector = createSelector([homeStateSelector], home => {
  return home.experimentMetaData;
});

export const hitExperimentDetailsSelector = createSelector([homeStateSelector], home => {
  return home.hitExperimentDetails;
});

// city country
export const tripDurationSelector = createSelector(flightSearchWidgetSelector, searchWidget => {
  return searchWidget.tripDuration;
});

// USE THIS WHERE DOM OW CHECK IS TO BE APPLIED
export const domesticOneWayTripSelector = createSelector(
  [journeyTypeSelector, travelTypeSelector],
  (journeyType, travelType) => {
    const isOneWay = journeyType === 'ow';
    const isDomestic = travelType === 'domestic';
    return isOneWay && isDomestic;
  }
);

export const isInternationalTripSelector = createSelector(
  [travelTypeSelector],
  travelType => travelType === 'international'
);

export const isModifySearchOpenInSRPSelector = createSelector(
  homeStateSelector,
  home => home.isModifySearchOpenInSRP
);

export const holidayInfoSelector = createSelector(homeStateSelector, home => home.holidayInfo);

export const homeOmnitureInfoSelector = createSelector(homeStateSelector, home => {
  return home?.homeOmnitureInfo;
});

export const selectedFareOptionInfoSelector = createSelector(homeStateSelector, home => {
  return home?.selectedFareOptionInfo;
});
